var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsCrowdenergy152(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.2 99.2",
    style: {
      enableBackground: "new 0 0 99.2 99.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_50"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M50.2,51.2c0.6,0,1-0.5,0.9-1L50.8,42c0-0.6-0.5-1-1-0.9c-0.6,0-1,0.5-0.9,1l0.4,8.2 C49.2,50.8,49.7,51.3,50.2,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M32.9,51.2c0.6,0,1-0.4,1-0.9l0.4-8.2c0-0.6-0.4-1-0.9-1c-0.6,0-1,0.4-1,0.9L32,50.2 C31.9,50.7,32.4,51.2,32.9,51.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M35.4,53.9l12.4,0c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1l-12.4,0c-0.6,0-1,0.4-1,1C34.4,53.4,34.8,53.9,35.4,53.9z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M52.8,53.9l9.7,0c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1l-9.7,0c-0.6,0-1,0.4-1,1C51.8,53.5,52.2,53.9,52.8,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M73.1,29.6l5.6-5.6c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-5.6,5.6c-0.4,0.4-0.4,1,0,1.4 C72.1,30,72.7,30,73.1,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M58.4,24c0.6,0,1-0.4,1-1v-7.9c0-0.6-0.4-1-1-1c-0.6,0-1,0.4-1,1V23C57.4,23.6,57.8,24,58.4,24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M43.6,29.6c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4l-5.6-5.6c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4 L43.6,29.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M29.3,67.8l-10.8,0c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1l10.8,0c0.6,0,1-0.4,1-1C30.3,68.3,29.8,67.8,29.3,67.8z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M20.5,53.9l9.7,0c0.6,0,1-0.4,1-1c0-0.6-0.4-1-1-1l-9.7,0c-0.6,0-1,0.4-1,1C19.5,53.5,20,53.9,20.5,53.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M73.1,56.3c-0.4-0.4-1-0.4-1.4,0c-0.4,0.4-0.4,1,0,1.4l5.6,5.6c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4 L73.1,56.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M75.7,42.9c0-9.6-7.8-17.3-17.3-17.3c-7.7,0-14.2,5-16.5,11.9H19c-0.5,0-0.9,0.4-1,0.9L12.1,84 c0,0.3,0,0.6,0.2,0.8c0.2,0.2,0.5,0.3,0.8,0.3h57c0.3,0,0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.2-0.8l-3.4-26.5 C72.5,54.4,75.7,49.1,75.7,42.9z M58.4,27.6c4.2,0,8.1,1.7,10.9,4.5c2.8,2.8,4.5,6.6,4.5,10.9c0,5.1-2.5,9.6-6.3,12.4l-2.2-16.9 c-0.1-0.5-0.5-0.9-1-0.9H44C46.2,31.7,51.8,27.6,58.4,27.6z M19.9,39.5h43.4L69,83.2H14.2L19.9,39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M31.9,70.9c-0.6,0-1,0.4-1,0.9l-0.4,8.5c0,0.6,0.4,1,0.9,1c0.6,0,1-0.4,1-0.9l0.4-8.5 C32.9,71.4,32.5,70.9,31.9,70.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M64.5,67.8l-11.2,0c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1l11.2,0c0.6,0,1-0.4,1-1C65.5,68.3,65.1,67.8,64.5,67.8z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M86.1,41.9h-7.9c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h7.9c0.6,0,1-0.4,1-1C87.1,42.4,86.7,41.9,86.1,41.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M48.5,67.9l-13.8,0c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1l13.8,0c0.6,0,1-0.4,1-1C49.5,68.3,49.1,67.9,48.5,67.9z "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M32.7,55.2c-0.6,0-1,0.4-1,0.9l-0.5,9.7c0,0.6,0.4,1,0.9,1c0.6,0,1-0.4,1-0.9l0.5-9.7 C33.7,55.7,33.3,55.2,32.7,55.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M51,66.9c0.6,0,1-0.5,0.9-1l-0.5-9.7c0-0.6-0.5-1-1-0.9c-0.6,0-1,0.5-0.9,1l0.5,9.7 C50,66.5,50.5,66.9,51,66.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFAF00",
    d: "M51.2,70.9c-0.6,0-1,0.5-0.9,1l0.4,8.5c0,0.6,0.5,1,1,0.9c0.6,0,1-0.5,0.9-1l-0.4-8.5 C52.3,71.3,51.8,70.9,51.2,70.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsCrowdenergy152);
export default __webpack_public_path__ + "static/media/icons-crowdenergy-152.97245933890603e8b3dc7bda56c0cd55.svg";
export { ForwardRef as ReactComponent };